import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { guestGuard } from './core/guards/guest.guard';
import { stageAccessGuard } from './core/guards/stage-access.guard';
import { entityIdResolver } from './core/resolvers/entity-id.resolver';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () =>
      import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    canActivate: [stageAccessGuard, authGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'tournaments',
    canActivate: [stageAccessGuard],
    loadComponent: () =>
      import('./features/tournaments/tournament-list/tournament-list.component').then(m => m.TournamentListComponent)
  },
  {
    path: 'tournaments/:id',
    canActivate: [stageAccessGuard],
    resolve: { entityId: entityIdResolver('tournament') },
    loadComponent: () =>
      import('./features/tournaments/tournament-detail/tournament-detail.component').then(m => m.TournamentDetailComponent)
  },
  {
    path: 'leagues',
    canActivate: [stageAccessGuard],
    loadComponent: () =>
      import('./features/leagues/league-standings/league-standings.component').then(m => m.LeagueStandingsComponent)
  },
  {
    path: 'profile',
    canActivate: [stageAccessGuard, authGuard],
    loadComponent: () =>
      import('./features/profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'friendly-matches',
    canActivate: [stageAccessGuard, authGuard],
    loadComponent: () =>
      import('./features/friendly-matches/friendly-match-hub.component').then(m => m.FriendlyMatchHubComponent)
  },
  {
    path: 'friendly-matches/:id',
    canActivate: [stageAccessGuard, authGuard],
    loadComponent: () =>
      import('./features/friendly-matches/friendly-match.component').then(m => m.FriendlyMatchComponent)
  },
  {
    path: 'player/:id',
    canActivate: [stageAccessGuard],
    loadComponent: () =>
      import('./features/players/player-profile/player-profile.component').then(m => m.PlayerProfileComponent)
  },
  {
    path: 'places',
    canActivate: [stageAccessGuard],
    loadComponent: () =>
      import('./features/places/place-list/place-list.component').then(m => m.PlaceListComponent)
  },
  {
    path: 'places/:id',
    canActivate: [stageAccessGuard],
    resolve: { entityId: entityIdResolver('place') },
    loadComponent: () =>
      import('./features/places/place-detail/place-detail.component').then(m => m.PlaceDetailComponent)
  },
  {
    path: 'admin',
    canActivate: [stageAccessGuard, authGuard, roleGuard],
    data: { roles: ['super_admin', 'admin'] },
    loadChildren: () =>
      import('./admin/admin.routes').then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'terms',
    canActivate: [stageAccessGuard],
    loadComponent: () =>
      import('./features/legal/terms/terms.component').then(m => m.TermsComponent)
  },
  {
    path: 'privacy',
    canActivate: [stageAccessGuard],
    loadComponent: () =>
      import('./features/legal/privacy/privacy.component').then(m => m.PrivacyComponent)
  },
  {
    path: 'cookie-policy',
    canActivate: [stageAccessGuard],
    loadComponent: () =>
      import('./features/legal/cookie-policy/cookie-policy.component').then(m => m.CookiePolicyComponent)
  },
  {
    path: 'stage-access-denied',
    loadComponent: () =>
      import('./features/stage-access-denied/stage-access-denied.component').then(m => m.StageAccessDeniedComponent)
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [stageAccessGuard],
    loadComponent: () =>
      import('./features/landing/landing-page.component').then(m => m.LandingPageComponent)
  },
  {
    // Without this, an unknown URL rendered an empty router outlet.
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
